<template>
  <v-card :dark="dark" :id="id" v-if="ready" :class="[draggable ? 'elevation-12' : null, rootCss, compact ? null : 'pa-0', draggable ? `${rootCss}-draggable` : null]" :style="{maxWidth: maxWidth, top: draggableSetup && draggableSetup.coords ? draggableSetup.coords.top : null, left: draggableSetup && draggableSetup.coords ? draggableSetup.coords.left : null}">
    <v-card-text :class="['pa-0']">
      <audio ref="audio" @timeupdate="onTimeUpdate" @ended="onAudioEnded" :src="src" />
      <v-card v-if="!compact">
        <v-card-title v-if="draggable" :class="[getColor(), 'mb-1', 'pa-2', `${rootCss}-draggable-handle`]">
          <div :class="['vc-audio-player-ellipsis']" v-if="draggableSetup && draggableSetup.titleText" v-html="draggableSetup.titleText" />
          <v-spacer />
          <v-btn @click="emitTitlebarAction(button.event, button.eventData)" small icon flat :class="['ma-0']" :title="button.hint" v-if="draggableSetup && draggableSetup.actions" v-for="(button, index) in draggableSetup.actions" :key="index">
            <v-icon>{{ button.icon }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="['pa-0']">
          <div :class="['table-layout']">
            <div>
              <div :style="{width: artWidth}" v-if="showArt && (art || (currentlyEnqueuedSong && currentlyEnqueuedSong.art))" :class="['pb-1', `${rootCss}-album-art-cell`]">
                <v-img :src="setPlayerArt()" :class="['elevation-4']" />
              </div>
              <div v-if="showInfoHeader && (artist || album || year)" :class="['px-2', `${rootCss}-media-info-cell`]">
                <div :class="['table-layout', `${rootCss}-media-info`]">
                  <div v-if="artist">
                    <div :class="['font-weight-regular', getColor(true)]" v-html="lang.artist" />
                    <div :class="['px-2']">
                      <div :class="['vc-audio-player-ellipsis']" v-html="artist" />
                    </div>
                    <div />
                  </div>
                  <div :class="['body-1', 'font-weight-light']" v-if="album">
                    <div :class="['font-weight-regular', getColor(true)]" v-html="lang.album" />
                    <div :class="['px-2']">
                      <div :class="['vc-audio-player-ellipsis']" v-html="album" />
                    </div>
                    <div :class="['text-xs-right', getColor(true)]" v-if="year" v-html="year" />
                  </div>
                  <div :class="['body-1', 'font-weight-light']">
                    <div :class="['font-weight-regular', getColor(true)]" v-html="lang.track" />
                    <div :class="['px-2']" v-html="currentlyEnqueuedSong.title" />
                    <div :class="['text-xs-right', getColor(true)]" v-html="formatTrackDuration(currentlyEnqueuedSong.duration)" v-if="currentlyEnqueuedSong.duration" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card :class="[compact ? null : 'mt-1']">
        <v-card-text :class="['py-1', 'px-0']">
          <div :class="['table-layout', `${rootCss}-player-controls`]">
            <div>
              <div :class="[`${rootCss}-controls`]">
                <div :class="[`${rootCss}-nowrap`, 'ml-1', 'pr-1']">
                  <template v-if="compact">
                    <v-img :title="currentlyEnqueuedSong.title" v-if="showArt && (art || (currentlyEnqueuedSong && currentlyEnqueuedSong.art))" :class="[`${rootCss}-small-art`, 'elevation-4', 'mr-1']" width="28px" :src="setPlayerArt()" />
                  </template>
                  <v-btn v-if="ifControlSet('previous')" small flat icon :title="lang.previous" :class="['ma-0']" @click="action('previous')">
                    <v-icon :color="getColor()">mdi-skip-previous</v-icon>
                  </v-btn>
                  <v-btn v-if="ifControlSet('playpause')" small flat icon :title="playing ? lang.pause : lang.play" :class="['ma-0']" @click="action(playing ? 'pause' : 'play')">
                    <v-icon :color="getColor()">{{ playing ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                  </v-btn>
                  <v-btn v-if="ifControlSet('next')" small flat icon :title="lang.next" :class="['ma-0']" @click="action('next')">
                    <v-icon :color="getColor()">mdi-skip-next</v-icon>
                  </v-btn>
                  <v-btn v-if="ifControlSet('stop')" small flat icon :title="lang.stop" :class="['ma-0']" @click="action('stop')">
                    <v-icon :color="getColor()">mdi-stop</v-icon>
                  </v-btn>
                  <v-btn v-if="ifControlSet('loop')" small flat icon :title="loop ? lang.loopOff : lang.loopOff" :class="['ma-0']" @click="action('loop')">
                    <v-icon :color="getColor()">{{ looping ? 'mdi-repeat' : 'mdi-repeat-off' }}</v-icon>
                  </v-btn>
                </div>
              </div>
              <div v-if="ifControlSet('title')" :class="[`${rootCss}-compact-title`, 'mx-1', 'hidden-xs-only']">
                <div :class="[`${rootCss}-ellipsis`, 'caption']">{{ currentlyEnqueuedSong.title.replace(/&\#39;/g, '\'') }}{{ artist ? ' ' + lang.by + ' ' + artist : null }}</div>
              </div>
              <div v-if="ifControlSet('scrobber')" :class="[`${rootCss}-scrobber`, 'mx-1']">
                <v-slider thumb-label :color="color" :class="['mt-0', 'mx-2']" hide-details @change="setCurrentTime" :value="currentTime" :max="scrobberMax" />
              </div>
              <div v-if="ifControlSet('volume')" :class="[`${rootCss}-volume`, 'pr-1']">
                <v-slider @click:append="setVolume(1)" @click:prepend="setVolume()" thumb-label :color="color" :class="['mt-0']" hide-details prepend-icon="mdi-volume-low" append-icon="mdi-volume-high" v-model="audioVolume" :step="0.1" :max="1" />
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <template v-if="!compact">
        <v-card :class="['mt-1']" v-if="tracks.length && showTrackList">
          <v-card-text :class="['pa-0']">
            <div :class="[`${rootCss}-tracklist-wrapper`]" :style="{maxHeight: trackListMaxHeight}">
              <v-list dense :class="['py-0']">
                <template v-for="(track, index) in tracks">
                  <v-list-tile :key="index" ripple :class="[index === currentlyEnqueuedSongIndex ? 'currently-enqueued-track' : null]" @click="enqueueTrack(index, true)" :title="track.title">
                    <v-list-tile-avatar>
                      <v-icon>mdi-music-note</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="track.title" />
                    </v-list-tile-content>
                    <v-list-tile-action v-html="formatTrackDuration(track.duration)" />
                    <v-list-tile-action v-if="trackActionIcon">
                      <v-btn :title="trackActionIconHint" icon flat small @click.stop="$emit('track-action-icon-click', track)">
                        <v-icon>{{ trackActionIcon }}</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider v-if="index < tracks.length - 1" :key="`divider-${index}`" />
                </template>
              </v-list>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import { v4 as uuidv4 } from 'uuid'
import Draggable from 'draggable'

momentDurationFormatSetup(moment)

export default {
  name: 'VcAudioPlayer',
  data () {
    return {
      rootCss: 'vc-audio-player',
      id: 'player--' + uuidv4(),
      src: null,
      ready: false,
      audioVolume: null,
      scrobber: 0,
      scrobberMax: 0,
      currentTime: 0,
      currentlyEnqueuedSong: null,
      currentlyEnqueuedSongIndex: null,
      looping: false,
      playing: false,
      events: {
        pauseAll: 'vc-player:pause-all'
      }
    }
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    draggableSetup: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    showInfoHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    dark: {
      type: Boolean,
      required: false,
      default: true
    },
    showTrackList: {
      type: Boolean,
      required: false,
      default: true
    },
    showArt: {
      type: Boolean,
      required: false,
      default: true
    },
    trackActionIcon: {
      type: String,
      required: false
    },
    trackActionIconHint: {
      type: String,
      required: false
    },
    maxWidth: {
      type: String,
      required: false,
      default: null
    },
    tracks: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    volume: {
      type: Number,
      required: false,
      default: 1 // 0 - 1
    },
    controls: {
      type: Array,
      required: false,
      default: () => {
        return [
          'previous',
          'playpause',
          'next',
          'stop',
          'loop',
          'scrobber',
          'volume'
        ]
      }
    },
    lang: {
      type: Object,
      required: false,
      default: () => {
        return {
          play: 'Play',
          pause: 'Pause',
          stop: 'Stop',
          previous: 'Previous',
          next: 'Next',
          album: 'Album',
          track: 'Track',
          artist: 'Artist',
          loopOn: 'Loop track',
          loopOff: 'Do not loop track',
          by: 'by'
        }
      }
    },
    artist: {
      type: String,
      required: false,
      default: null
    },
    art: {
      type: String,
      required: false,
      default: null
    },
    artWidth: {
      type: String,
      required: false,
      default: '64px'
    },
    album: {
      type: String,
      required: false,
      default: null
    },
    trackListMaxHeight: {
      type: String,
      required: false,
      default: null
    },
    year: {
      type: [
        Number,
        String
      ],
      required: false,
      default: null
    },
    defaultTrack: {
      type: [
        Number,
        String
      ],
      required: false,
      default: 0
    },
    autoPlayNext: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  watch: {
    tracks () {
      this.enqueueTrack(this.defaultTrack)
      if (!this.ready) {
        this.ready = true
        this.$nextTick(() => {
          const id = this.id
          this.audioVolume = this.volume
          if (this.draggable) {
            const boundsCssClass = 'vc-audio-player-draggable-bounds'
            if (!document.querySelector(`.${boundsCssClass}`)) {
              const boundElement = document.createElement('div')
              boundElement.classList.add(boundsCssClass)
              document.querySelector('body').appendChild(boundElement)
            }
            /* eslint-disable no-new */
            new Draggable(document.getElementById(id), {
              setPosition: false,
              limit: document.querySelector(`.${boundsCssClass}`),
              handle: document.querySelector(`#${id} .vc-audio-player-draggable-handle`)
            })
          }
        })
      }
    },
    audioVolume () {
      this.$refs['audio'].volume = this.audioVolume
    }
  },
  created () {
    this.$root.$on(this.events.pauseAll, (id) => {
      if (id !== this.id) {
        this.pause()
      }
    })
  },
  methods: {
    getColor (text = false) {
      let colors = this.color.split(/\s+/)
      if (text) {
        colors.forEach((color, index) => {
          if (index === 0) {
            colors[index] = color + '--text'
          } else if (index === 1) {
            colors[index] = 'text--' + color
          }
        })
      }
      return colors.join(' ')
    },
    setVolume (volume = 0) {
      this.audioVolume = volume
    },
    ifControlSet (control) {
      return this.controls.includes(control)
    },
    setCurrentTime ($event) {
      this.$refs['audio'].currentTime = $event
    },
    onTimeUpdate () {
      this.currentTime = this.$refs['audio'].currentTime
    },
    setPlayerArt () {
      return !this.playing ? this.art : this.currentlyEnqueuedSong.art
    },
    formatTrackDuration (duration) {
      return moment.duration(duration, 'minutes').format('h:mm')
    },
    onAudioEnded () {
      if (this.autoPlayNext) {
        this.next()
      } else {
        this.stop()
      }
    },
    enqueueTrack (index, play) {
      this.currentlyEnqueuedSong = this.tracks[index]
      this.currentlyEnqueuedSongIndex = index
      this.src = this.currentlyEnqueuedSong.src
      this.scrobberMax = this.currentlyEnqueuedSong.duration
      if (play) {
        this.$nextTick(() => {
          this.play()
        })
      }
    },
    action (action) {
      this[action]()
    },
    player () {
      return this.$refs['audio']
    },
    play () {
      this.$root.$emit('vc-player:pause-all', this.id)
      this.playing = true
      this.player().play()
      this.$root.$emit('play', this.currentlyEnqueuedSong)
    },
    pause () {
      this.playing = false
      this.player().pause()
    },
    stop () {
      this.player().currentTime = 0
      this.pause()
    },
    loop () {
      this.looping = !this.looping
      this.player().loop = this.looping
    },
    next () {
      const index = this.currentlyEnqueuedSongIndex + 1
      this.trackExists(index) ? this.enqueueTrack(index, true) : this.enqueueTrack(0, true)
    },
    previous () {
      const index = this.currentlyEnqueuedSongIndex - 1
      this.trackExists(index) ? this.enqueueTrack(index, true) : this.enqueueTrack(this.tracks.length - 1, true)
    },
    trackExists (index) {
      return !!this.tracks[index]
    },
    emitTitlebarAction (action, data) {
      this.$emit(action, data)
    }
  }
}
</script>
<style>
.vc-audio-player
{
  cursor: default;
  user-select: none;
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.vc-audio-player .vc-audio-player-nowrap
{
  white-space: nowrap;
}

.vc-audio-player.theme--dark .currently-enqueued-track a
{
  background: hsla(0, 0%, 100%, .08);
}

.vc-audio-player.theme--light .currently-enqueued-track a
{
  background: rgba(0, 0, 0, .05);
}

.vc-audio-player .table-layout
{
  display: table;
  width: 100%;
  border-collapse: collapse;
}

.vc-audio-player .table-layout > *
{
  display: table-row;
}

.vc-audio-player .table-layout > * > *
{
  display: table-cell;
  vertical-align: middle;
}

.vc-audio-player .vc-audio-player-volume
{
  width: 30%;
}

.vc-audio-player .vc-audio-player-scrobber
{
  width: 70%;
}

.vc-audio-player .vc-audio-player-media-info
{
  height: 100%;
}

.vc-audio-player .vc-audio-player-compact-title
{
  width: 70%;
}

.vc-audio-player .vc-audio-player-ellipsis
{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
}

.vc-audio-player .vc-audio-player-tracklist-wrapper
{
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.vc-audio-player
{
  cursor: default;

}

.vc-audio-player.theme--dark ::-webkit-scrollbar,
.vc-audio-player.theme--dark ::-webkit-scrollbar-track
{
  background-color: #424242;
}

.vc-audio-player.theme--light ::-webkit-scrollbar,
.vc-audio-player.theme--light ::-webkit-scrollbar-track
{
  background-color: #ccc;
}

.vc-audio-player ::-webkit-scrollbar
{
  width: 10px;
}

.vc-audio-player.theme--dark ::-webkit-scrollbar-thumb
{
  background-color: #212121;
}

.vc-audio-player.theme--light ::-webkit-scrollbar-thumb
{
  background-color: #757575;
}

.vc-audio-player .vc-audio-player-small-art
{
  display: inline-flex;
  vertical-align: middle;
}

.vc-audio-player.vc-audio-player-draggable
{
  position: fixed;
}

.vc-audio-player .vc-audio-player-draggable-handle
{
  cursor: move;
}

.vc-audio-player-draggable-bounds
{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  pointer-events: none;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components-third-party/vc-audio-player/vc-audio-player.vue